import { jsx as o } from "react/jsx-runtime";
import { L as n, j as i } from "./index-B_Mi3W2t.js";
import { C as m } from "./ConsentSteps-Boru81Lg.js";
const f = ({
  modalRoot: r,
  onCancel: s,
  consent: t,
  handleSubmitConsent: a,
  onError: e
}) => /* @__PURE__ */ o(n, { fallback: /* @__PURE__ */ o(i, {}), children: /* @__PURE__ */ o(
  m,
  {
    modalRoot: r,
    onCancel: s,
    consent: t,
    handleSubmitConsent: a,
    onError: e
  }
) });
export {
  f as C
};
//# sourceMappingURL=ConsentFlow-nrmwvKF-.js.map
